import { LocationOn } from '@mui/icons-material';
import { Link, Stack, Typography } from '@mui/material';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useUserLocations } from '/@/hooks/user';
import { _ } from '/@/locale';
import { getSessionCountry } from '/@/store/session/selectors';

const LocationsSelector = ({ onClick }: { onClick: VoidFunction }) => {
    const country = useSelector(getSessionCountry);
    const userLocationsQuery = useUserLocations({ level: 2, pageSize: 100000 }, { enabled: !!country });

    const { i18n } = useTranslation();

    const locationsResumee = useMemo(() => {
        const locations = userLocationsQuery.data?.results || [];

        if (locations.length === 0) return _('Configurar ubicación');

        let message: string = locations
            .slice(0, 2)
            .map((l) => l.name)
            .join(', ');

        if (locations.length >= 3) {
            message +=
                ' ' +
                _('y {{quantity}} más', {
                    quantity: locations.length - 2,
                });
        }

        return message;
    }, [userLocationsQuery.data?.results, i18n.resolvedLanguage]);

    return (
        <Link to='NewHome' sx={{ cursor: 'pointer' }} onClick={onClick}>
            <Stack spacing={1} direction='row' alignItems='center' sx={{ height: '38px' }}>
                <LocationOn sx={{ width: '24px', height: '24px' }} />
                <Typography color='primary' variant='body1'>
                    {locationsResumee}
                </Typography>
            </Stack>
        </Link>
    );
};

export default LocationsSelector;
